<template>
    <div>
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>

        <div>
            <FormulateForm
                v-model="formData"
                :schema="finalSchema"
                @submit="handleSubmit"
                #default="{ isLoading }"
            >  <!-- @cancel="handleCollectDataCancel"  moved to button itself, but this works if adding button using form schema -->
                <!-- :keep-model-data="true" works fine -- but the data still gets sent!  don't want that --> 
                <div class="mt-5 d-flex justify-content-end gap-2">
                    <!-- <FormulateInput
                        type="button"
                        label="Cancel"
                        :outer-class="['minimal']"
                        @click="handleCollectDataCancel"
                        :disabled="isLoading"
                    /> -->
                    <!-- Modal header (and therefore close button) is hidden so we must always show this -->
                    <FormulateInput
                        type="submit"
                        name="submit"
                        :label="isLoading ? 'Loading...' : 'Submit'"
                        :disabled="isLoading"
                    />
                </div>
            </FormulateForm>
        </div>

        <!-- <h5>Schema</h5>
        <pre>{{ formSchema }}</pre> -->
    </div>
</template>

<script>
import { suppliosApi } from '../../js/api-service';
import { errorHandling } from '../../js/custom-vue-mixins';

export default {
    name: 'MultiPageFormPage',
    components: {},
    mixins: [
        errorHandling,
    ],
    props: {
        schema: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            errorMsg: 'Error',
            error: false,
            loadingForm: false,
            submittingForm: false,
            // FORM
            formData: {},
            formSchema: null,
            finalSchema: null, 
            
        }
    },
    computed: {

    },
    created() {
        this.finalSchema = this.schema;  // probably unnecessary...
    },
    mounted() {
        //this.getForm();
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        async getForm() {
            this.loadingForm = true;
            try {
                const { data } = await suppliosApi.workflowForms.getTestForm();
                this.formSchema = data;
                this.setFinalSchema(data);
            } catch (err) {
                this.apiErrorHandler(err);
            }
            this.loadingForm = false;
        },
        setFinalSchema(apiSchema) {
            this.finalSchema = apiSchema;  // for now...
        },
        async handleSubmit(submitData) {
            this.submittingForm = true;
            // make this async and call it from form @submit -- then FormulateForm will automatically expose 'isLoading' property on the form context object
            console.log('HELLO FROM handleSubmit', submitData);
            try {
                const { data } = await suppliosApi.workflowForms.postTestForm(submitData);
                console.log('Response data from POSTing data to server', data);
            } catch (err) {
                this.apiErrorHandler(err);
            }
            this.submittingForm = false;
        },
    }
}
</script>

<style>

</style>